import { render } from "./ClosePoNotifModal.vue?vue&type=template&id=6dff6460"
import script from "./ClosePoNotifModal.vue?vue&type=script&lang=js"
export * from "./ClosePoNotifModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__